export const sortOptionValues = ["order", "name", "-name", "created_at", "-created_at", "updated_at", "-updated_at"];
export const visibleChildPartnerTags = ["RM", "RM RT", "RT", "KRMT"];
